'use client';

import React from 'react';

import { useParams } from 'next/navigation';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { useBlogTracking } from '@/modules/blog/hooks/useBlogTracking';
import { type BlogArticleImageWithLink } from '@/modules/blog/types';

type Props = {
  entry: BlogArticleImageWithLink;
};

export function ArticleImageWithLink({ entry }: Props) {
  const { sendBlogInteractionActionEvent } = useBlogTracking();
  const { slug } = useParams<{ slug: string }>();

  function handleClick() {
    sendBlogInteractionActionEvent({
      interactionType: 'ArticleImageLinkClick',
      articleSlug: slug,
      itemName: entry.link,
    });
  }

  if (!entry.image || !entry.link) {
    return null;
  }

  return (
    <ExtendedLink
      href={entry.link}
      target={entry.openInNewTab ? '_blank' : '_self'}
      rel={entry.openInNewTab ? 'noopener noreferrer' : undefined}
      className={styles.link}
      onClick={handleClick}
    >
      <img src={entry.image.url} alt={entry.image.description || ''} />
    </ExtendedLink>
  );
}
